import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { getValueFromTextNode } from "@smithy/smithy-client";
import { XMLParser } from "fast-xml-parser";
import { collectBodyString } from "../common";
export var parseXmlBody = function parseXmlBody(streamBody, context) {
  return collectBodyString(streamBody, context).then(function (encoded) {
    if (encoded.length) {
      var parser = new XMLParser({
        attributeNamePrefix: "",
        htmlEntities: true,
        ignoreAttributes: false,
        ignoreDeclaration: true,
        parseTagValue: false,
        trimValues: false,
        tagValueProcessor: function tagValueProcessor(_, val) {
          return val.trim() === "" && val.includes("\n") ? "" : undefined;
        }
      });
      parser.addEntity("#xD", "\r");
      parser.addEntity("#10", "\n");
      var parsedObj;
      try {
        parsedObj = parser.parse(encoded, true);
      } catch (e) {
        if (e && typeof e === "object") {
          Object.defineProperty(e, "$responseBodyText", {
            value: encoded
          });
        }
        throw e;
      }
      var textNodeName = "#text";
      var key = Object.keys(parsedObj)[0];
      var parsedObjToReturn = parsedObj[key];
      if (parsedObjToReturn[textNodeName]) {
        parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
        delete parsedObjToReturn[textNodeName];
      }
      return getValueFromTextNode(parsedObjToReturn);
    }
    return {};
  });
};
export var parseXmlErrorBody = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(errorBody, context) {
    var value, _value$Error$message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return parseXmlBody(errorBody, context);
          case 2:
            value = _context.sent;
            if (value.Error) {
              value.Error.message = (_value$Error$message = value.Error.message) !== null && _value$Error$message !== void 0 ? _value$Error$message : value.Error.Message;
            }
            return _context.abrupt("return", value);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function parseXmlErrorBody(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var loadRestXmlErrorCode = function loadRestXmlErrorCode(output, data) {
  var _data$Error;
  if ((data === null || data === void 0 ? void 0 : (_data$Error = data.Error) === null || _data$Error === void 0 ? void 0 : _data$Error.Code) !== undefined) {
    return data.Error.Code;
  }
  if ((data === null || data === void 0 ? void 0 : data.Code) !== undefined) {
    return data.Code;
  }
  if (output.statusCode == 404) {
    return "NotFound";
  }
};